import { PSCType, SQDCEventActionTypeInternalType, SQDCEventActionTypePreset } from "@/graphql";
import type { RouteRecordRaw } from "vue-router";

const router: RouteRecordRaw[] = [
  {
    path: "/psc",
    name: "PSC",
    redirect: {
      name: "PSCOverviews",
    },
    children: [
      {
        path: "overview",
        name: "PSCOverviews",
        redirect: {
          name: "PSCOverview",
          params: {
            type: PSCType.A3,
          },
        },
        children: [
          {
            path: "kaizen",
            name: "PSCOverviewKaizen",
            meta: {
              rights: ["sqdc.read"],
            },
            redirect: {
              name: "PSCOverview",
              params: {
                type: PSCType.Kaizen,
              },
            },
          },
          {
            path: "archive",
            name: "PSCOverviewArchive",
            meta: {
              rights: ["sqdc.read"],
            },
            redirect: {
              name: "PSCOverview",
              params: {
                type: PSCType.A3,
                archive: "true",
              },
            },
          },
          {
            path: ":type/:archive?",
            name: "PSCOverview",
            component: () => import("./views/PSCOverview.vue"),
            meta: {
              rights: ["sqdc.read"],
            },
            props: (route) => ({
              archive: route.params.archive === "true",
              type: route.params.type as PSCType,
            }),
          },
        ],
      },
      {
        path: "create/:type",
        name: "PSCCreate",
        component: () => import("./views/PSCCreate.vue"),
        meta: {
          rights: ["sqdc.write"],
        },
        props: (route) => ({
          type: route.params.type,
          eventId: route.query.eventId ? Number(route.query.eventId) : undefined,
          eventType: route.query.eventType,
        }),
      },
      {
        path: "edit/:id",
        name: "PSCEdit",
        component: () => import("./views/PSCEdit.vue"),
        meta: {
          rights: ["sqdc.read"],
        },
        props: (route) => ({
          id: Number(route.params.id),
        }),
      },
      {
        path: "configOverview",
        name: "PSCConfigOverview",
        component: () =>
          import("@/modules/sqdc/components/eventActionConfig/SQDCEventActionTypeConfigOverview.vue"),
        meta: {
          rights: ["sqdc.admin"],
        },
        props: {
          internalType: SQDCEventActionTypeInternalType.PSC,
          presets: [SQDCEventActionTypePreset.A3, SQDCEventActionTypePreset.EightD],
          titleKey: "router.PSCConfigOverview",
        },
      },
    ],
  },
];

export default router;
